"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const Tracker_1 = require("@/classes/Tracker");
const routes_1 = require("@/enums/routes");
const Introduction_vue_1 = __importDefault(require("./components/pages/introduction/Introduction.vue"));
const Question_vue_1 = __importDefault(require("./components/pages/question/Question.vue"));
const RegistrationForm_vue_1 = __importDefault(require("./components/pages/registration-form/RegistrationForm.vue"));
const Results_vue_1 = __importDefault(require("./components/pages/results/Results.vue"));
const store_1 = __importDefault(require("@/store"));
exports.default = (0, vue_1.defineComponent)({
    setup: () => {
        const routes = {
            [routes_1.Routes.HOME]: Introduction_vue_1.default,
            [routes_1.Routes.QUESTION]: Question_vue_1.default,
            [routes_1.Routes.FORM]: RegistrationForm_vue_1.default,
            [routes_1.Routes.RESULTS]: Results_vue_1.default
        };
        const router = (0, vue_1.computed)(() => {
            return store_1.default.getters.router();
        });
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const CurrentComponent = (0, vue_1.computed)(() => {
            return routes[router.value.current];
        });
        (0, vue_1.onMounted)(() => {
            Tracker_1.CountryTestTracker.fireTracking('impression');
        });
        return { router, CurrentComponent };
    }
});
